import React from "react";
import classes from "./Checkbox.module.scss";
import { ReactComponent as CheckmarkIcon } from "../../assets/icons/checkmark.svg";

interface CheckboxProps {
  isSelected: boolean;
}
export const Checkbox: React.FC<CheckboxProps> = ({ isSelected, ...props }) => {
  return (
    <div className={classes.checkBox}>{isSelected && <CheckmarkIcon />}</div>
  );
};
